import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ReportService } from '../../../../core/services/report.service';
import { ToKbpsPipe } from '../../../../shared/pipes/to-kbps.pipe';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ToMbpsPipe } from '../../../../shared/pipes/to-mbps.pipe';
import { PrecallReportStep } from '../../../../models/app/precall/precall-report-step';
import { StatusIconPipe } from 'src/app/shared/pipes/status-icon.pipe';

@Component({
  selector: 'app-precall-report-step',
  imports: [ToKbpsPipe, ToMbpsPipe, DecimalPipe, DatePipe, StatusIconPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './precall-report-step.component.html',
})
export class PrecallReportStepComponent {
  service = inject(ReportService);
  report = signal<PrecallReportStep | null>(null);

  start() {
    this.report.set(this.service.report());
  }

  mos = computed(() => {
    const report = this.report();
    const pingMos = report?.quality.ping?.mos || 0;
    const downloadMos = report?.quality.download?.mos || 0;
    const uploadMos = report?.quality.upload?.mos || 0;

    console.log('MOS values:', pingMos, downloadMos, uploadMos);
    return Math.min(pingMos, downloadMos, uploadMos);
  });
}
